import PropTypes from "prop-types";

import mixColorWithWhite from "../../../TreatmentPage/utils/helperFn";

import avatarImage from "./../../../../assets/images/avatar.svg";
export function UserProfile({ clientInfo }) {
  return (
    <>
      <div className="m-r-5 ic-15 d-flex align-items-center justify-content-center">
        {clientInfo?.profile_pic_29p ? (
          <img
            src={clientInfo.profile_pic_29p}
            alt="Profile avatar ic-15 d-flex align-items-center justify-content-center"
            className=""
            style={{
              height: "15px",
              borderRadius: "50%",
            }}
          />
        ) : (
          <img
            style={{
              width: "15px",
              height: "15px",
              background: "var(--primary-30)",
              borderRadius: "50%",
            }}
            src={avatarImage}
            className="ic ic-15 theme-ring has-avatar-icon d-flex align-items-center justify-content-center"
          />
        )}
      </div>

      <span
        className="clientTabFont d-flex align-items-center height-25"
        style={{ fontSize: "14px", fontWeight: "600" }}
      >
        {clientInfo ? `${clientInfo.last_name}, ${clientInfo.first_name}` : "Client Info"}
      </span>
    </>
  );
}

UserProfile.propTypes = {
  clientInfo: PropTypes.shape({
    profile_pic_29p: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }),
};

export function PageInfo({ page, documentSlot, panel, file_name }) {
  const { page_icon = "", name = "" } = page || {};
  return (
    <div
      className="d-flex flex-column"
      style={{
        minHeight: "21px",
        maxHeight: "63px",
      }}
    >
      <div
        className="text-bold p-l-5 d-flex align-items-center"
        style={{
          height: "21px",
          fontWeight: "600",
          gap: "5px",
        }}
      >
        <span className="">
          {page_icon && (
            <img
              src={page_icon}
              className="ic ic-15 d-flex align-items-center justify-content-center"
              alt=""
              style={{
                width: "15px",
                height: "15px",
              }}
            />
          )}
        </span>
        {name} Page
        {/* {documentSlot === null || documentSlot?.slot_number === 0 ? "Generally" : ""} */}
      </div>

      {documentSlot !== null &&
        documentSlot?.slot_number !== 0 &&
        documentSlot?.page?.name === "Treatment" && (
          <div
            className="text-bold"
            style={{
              fontWeight: 600,
            }}
          >
            <div
              className="d-flex align-items-center"
              style={{
                width: "100%",
                gap: "5px",
                background: mixColorWithWhite(panel?.specialty?.color, 10),
              }}
            >
              <span
                style={{
                  background: panel?.specialty?.color,
                  height: "21px",
                  width: "21px",
                  minWidth: "21px",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {panel?.specialty?.name[0]}
              </span>

              <span
                style={{
                  flex: 1,
                  width: "194px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {panel?.panel_name}
              </span>
            </div>
          </div>
        )}

      {documentSlot?.page?.name !== "Treatment" && page?.panels && (
        <div
          className="text-bold p-l-5"
          style={{
            fontWeight: 600,
          }}
        >
          <div
            className="d-flex align-items-center"
            style={{
              width: "100%",
              gap: "5px",
            }}
          >
            <span
              style={{
                flex: 1,
                width: "215px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {panel?.panel_name}
            </span>
          </div>
        </div>
      )}

      {documentSlot !== null && documentSlot?.slot_number !== 0 && (
        <div
          className="text-bold p-l-5 p-r-5 d-flex align-items-center"
          style={{
            minHeight: "21px",
            fontWeight: 600,
            flex: 1,
            width: "100%",
            gap: "5px",
          }}
        >
          <span className="text-primary-25 text-center" style={{ width: "15px" }}>
            {documentSlot?.slot_number}.
          </span>
          <span
            style={{
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: !page?.panels ? "" : "nowrap",
            }}
          >
            {documentSlot?.slot_name === null ? file_name : documentSlot?.slot_name}
          </span>
        </div>
      )}
    </div>
  );
}

// export function PageInfo({ page, photoSlot, panel }) {
//   const { page_icon = "", name = "" } = page || {};

//   return (
//     <div
//       className="d-flex flex-column"
//       style={{
//         height: "63px",
//       }}
//     >
//       <div
//         className="text-bold d-flex align-items-center"
//         style={{
//           height: "21px",
//           fontWeight: "600",
//           gap: "5px",
//         }}
//       >
//         <span className="">
//           {page_icon && (
//             <img
//               src={page_icon}
//               className="ic ic-15 d-flex align-items-center justify-content-center"
//               alt=""
//             />
//           )}
//         </span>
//         {name}
//       </div>

//       {panel?.panel_name && (
//         <div
//           className="text-bold"
//           style={{
//             height: "21px",
//             fontWeight: 600,
//             whiteSpace: "normal",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//           }}
//         >
//           {panel?.panel_name}
//         </div>
//       )}

//       <div
//         className="text-bold"
//         style={{
//           height: "21px",
//           fontWeight: 600,
//           whiteSpace: "normal",
//           overflow: "hidden",
//           textOverflow: "ellipsis",
//         }}
//       >
//         {photoSlot?.slot_number}. {photoSlot?.slot_name}
//       </div>
//     </div>
//   );
// }

PageInfo.propTypes = {
  page: PropTypes.shape({
    page_icon: PropTypes.string,
    name: PropTypes.string,
  }),
};
